import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoImage from "../assets/icons/logo.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import useTheme from "@mui/material/styles/useTheme";

// Custom Styled Component for the Logo
const Logo = styled("img")({
  height: "60px",
  marginTop: "0.7em",
  cursor: "pointer",
});

// Styled component for the AppBar to customize the color of Tabs
const CustomTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: "#4D8F55",
  },
  "& .MuiTab-root": {
    color: "black",
    "&.Mui-selected": {
      color: "#4D8F55",
    },
  },
});

// Styled component for drawer menu items
const DrawerMenuItem = styled(Typography)(({ theme }) => ({
  padding: "20px",
  width: "100%",
  textAlign: "left",
  cursor: "pointer",
  color: "white",
  borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "#2B4D30",
  },
  "&:last-child": {
    borderBottom: "none",
  },
}));

const MenuButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
});

const TopAppBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  React.useEffect(() => {
    // Sync tab value with the current route
    switch (location.pathname) {
      case "/":
        setValue(0);
        break;
      case "/blog":
        setValue(1);
        break;
      case "/contact":
        setValue(2);
        break;
      case "/services":
        setValue(3);
        break;
      // ADD: highlight the tab if user is on /inteligenta-artificiala
      case "/inteligenta-artificiala":
        setValue(4);
        break;
      default:
        setValue(false);
    }
  }, [location]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleMenuItemClick = (path) => {
    setIsDrawerOpen(false);
    navigate(path);
  };

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <AppBar position="static" color="default">
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0 2em",
        }}
      >
        {/* Logo on the left */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Logo src={LogoImage} alt="Logo" onClick={handleLogoClick} />
        </Box>

        {/* Navigation - Different for mobile and desktop */}
        {isMobile ? (
          <>
            <MenuButton onClick={handleDrawerToggle}>
              <MenuIcon />
              <Typography>Menu</Typography>
            </MenuButton>
            <Drawer
              anchor="top"
              open={isDrawerOpen}
              onClose={handleDrawerToggle}
              PaperProps={{
                sx: {
                  width: "100%",
                  backgroundColor: "#4D8F55",
                },
              }}
            >
              <Box sx={{ width: "100%", backgroundColor: "#4D8F55" }}>
                <DrawerMenuItem onClick={() => handleMenuItemClick("/")}>
                  Acasă
                </DrawerMenuItem>
                <DrawerMenuItem onClick={() => handleMenuItemClick("/blog")}>
                  Blog
                </DrawerMenuItem>
                <DrawerMenuItem onClick={() => handleMenuItemClick("/contact")}>
                  Contact
                </DrawerMenuItem>
                <DrawerMenuItem onClick={() => handleMenuItemClick("/services")}>
                  Services
                </DrawerMenuItem>
                {/* NEW MOBILE MENU ITEM */}
                <DrawerMenuItem
                  onClick={() => handleMenuItemClick("/inteligenta-artificiala")}
                >
                  Inteligență artificială
                </DrawerMenuItem>
              </Box>
            </Drawer>
          </>
        ) : (
          <CustomTabs
            value={value}
            onChange={handleChange}
            aria-label="nav tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab label="Acasă" component={Link} to="/" />
            <Tab label="Blog" component={Link} to="/blog" />
            <Tab label="Contact" component={Link} to="/contact" />
            <Tab label="Services" component={Link} to="/services" />
            {/* NEW DESKTOP TAB */}
            <Tab
              label="Inteligență artificială"
              component={Link}
              to="/inteligenta-artificiala"
            />
          </CustomTabs>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default TopAppBar;
